module.exports = __webpack_public_path__ + "img/antes_despues_306.47d63965.png";